/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import 'quasar/dist/quasar.ie.polyfills.js'



import '@quasar/extras/mdi-v5/mdi-v5.css'

import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'




// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/app.scss'

import '@quasar/quasar-ui-qiconpicker/src/index.sass'

import '@quasar/quasar-app-extension-qpdfviewer/src/component/pdfviewer.sass'

import '@quasar/quasar-ui-qmarkdown/src/index.sass'


import Vue from 'vue'
import createApp from './app.js'




import qboot_Booti18n from 'boot/i18n'

import qboot_Bootaxios from 'boot/axios'

import qboot_Bootvalidation from 'boot/validation'

import qboot_Bootmoment from 'boot/moment'

import qboot_Bootcaptcha from 'boot/captcha'

import qboot_Bootfilters from 'boot/filters'

import qboot_Bootunderscore from 'boot/underscore'

import qboot_Bootapp_specific from 'boot/app_specific'

import qboot_Bootfirebase from 'boot/firebase'

import qboot_Quasarquasarappextensionqiconpickersrcbootregisterjs from '@quasar/quasar-app-extension-qiconpicker/src/boot/register.js'

import qboot_Quasarquasarappextensionqpdfviewersrcbootqpdfviewerjs from '@quasar/quasar-app-extension-qpdfviewer/src/boot/qpdfviewer.js'

import qboot_Quasarquasarappextensionqmarkdownsrcbootregisterjs from '@quasar/quasar-app-extension-qmarkdown/src/boot/register.js'







Vue.config.devtools = true
Vue.config.productionTip = false






const publicPath = ``


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Booti18n,qboot_Bootaxios,qboot_Bootvalidation,qboot_Bootmoment,qboot_Bootcaptcha,qboot_Bootfilters,qboot_Bootunderscore,qboot_Bootapp_specific,qboot_Bootfirebase,qboot_Quasarquasarappextensionqiconpickersrcbootregisterjs,qboot_Quasarquasarappextensionqpdfviewersrcbootqpdfviewerjs,qboot_Quasarquasarappextensionqmarkdownsrcbootregisterjs]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
